import React, { useCallback, useEffect, useState } from 'react'
import { createMessage } from '../../utilities/utilities';
import { handleError } from '../../utilities/errorHandler';
import { Container } from 'react-bootstrap';
import PageTitle from '../shared/PageTitle';
import Message from '../shared/Message';
import CustomLoader from '../shared/CustomLoader';
import SecurityLogsTable from '../tables/SecurityLogsTable';
import { allSecurityLogs } from '../../services/securityLogs';

const SecurityLogs = () => {
    const [ isLoading, setIsLoading ] = useState(false);
    const [ securityLogs, setSecurityLogs ] = useState([]);
    const [ message, setMessage ] = useState({
        text: '',
        variant: '',
        show: false
    });

    const handleMessage = (text, variant) => {
        setMessage(createMessage(text, variant));
    }

    const handleCloseMessage = () => {
        setMessage((prevMessage) => ({...prevMessage, show: false}));
    }

    const getSecurityLogs = useCallback(async () => {
        setIsLoading(true);

        try {
            const response = await allSecurityLogs();
            if (response.status === 200){
                setSecurityLogs(response.data);
            }
        } catch(error) {
            const errorMessage = handleError(error);
            if (errorMessage){
                handleMessage(errorMessage.text, 'danger');
            }
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        getSecurityLogs();
    }, []);

  return (
    <Container fluid>

        <PageTitle title='Duty Logs' />

        <Message
            message={message.text}
            variant={message.variant}
            show={message.show}
            handleClose={handleCloseMessage}
        />

        {
            isLoading ? (
                <CustomLoader />
            ) : (
                <SecurityLogsTable
                    securityLogs={securityLogs}
                />
            )
        }

    </Container>
  )
}

export default SecurityLogs